import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import TagBasedForum from '../ForumMode/TagBasedForum';
import GuestBanner from './GuestBanner';

/**
 * 訪客標籤論壇模式 - 極簡 stateless 包裝器
 * 職責：設置 sessionStorage 並渲染對應組件
 */
export default function GuestTaggedForum() {
  const { activityId, groupId } = useParams();
  
  // ✅ 在渲染前同步設置 sessionStorage（避免競態條件）
  sessionStorage.setItem('activityId', activityId);
  sessionStorage.setItem('groupId', groupId);
  sessionStorage.setItem('isGuestMode', 'true');
  
  useEffect(() => {
    // 清理函數：離開時清除訪客模式標記
    return () => {
      sessionStorage.removeItem('isGuestMode');
    };
  }, []);
  
  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <GuestBanner />
      <div style={{ flex: 1, overflow: 'auto', position: 'relative' }}>
        <TagBasedForum showNavbar={false} />
      </div>
    </div>
  );
}
